import { cn } from '@/lib/utils';
import { FormSectionContainerProps } from './types';

export function FormSectionContainer({ children, className }: FormSectionContainerProps) {
  return (
    <div className={cn('w-full max-w-2xl mx-auto p-6 space-y-6', className)}>
      {children}
    </div>
  );
} 